import { render, staticRenderFns } from "./DocumentsHistory.vue?vue&type=template&id=763b0c8d&scoped=true&"
import script from "./DocumentsHistory.vue?vue&type=script&lang=js&"
export * from "./DocumentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsHistory.vue?vue&type=style&index=0&id=763b0c8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b0c8d",
  null
  
)

export default component.exports